import styled from "styled-components";

export const CarouselWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const EmptyImg = styled.img`
  height: 10rem;
`;
